import styled from 'styled-components';

export const HomeCtr = styled.div`
  position: absolute;
  top: 10px;
  left: ${({ closed }) => (closed ? '110px' : '330px')};
  height: 97%;
  width: calc(99% - ${({ closed }) => (closed ? '110px' : '320px')});
  background-color: var(--body-color);
  transition: var(--tran-05);

  .text {
    display: flex;
    justify-content: center;
    font-size: 30px;
    font-weight: 500;
    color: var(--text-color);
  }
`;
